import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '@/api'

import './assets/flexible'; // rem配置，37.5
import './assets/style/main.less';

import { Icon, Overlay, Toast } from 'vant';
Vue.use(Overlay);
Vue.use(Icon);
Vue.use(Toast);

import SlideVerify from 'vue-monoplasty-slide-verify';
Vue.use(SlideVerify);

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
